import { render, staticRenderFns } from "./AgeVerificationStatusView.vue?vue&type=template&id=6fec9d0e&scoped=true&"
import script from "./AgeVerificationStatusView.vue?vue&type=script&lang=ts&"
export * from "./AgeVerificationStatusView.vue?vue&type=script&lang=ts&"
import style0 from "./AgeVerificationStatusView.vue?vue&type=style&index=0&id=6fec9d0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fec9d0e",
  null
  
)

export default component.exports